<template>
    <v-col md="6" sm="12" xl="3" lg="3" class="pa-0" style="border-style:solid;border-width:1px;border-color:#00000030;">
        <div style="height:250px;width:250px;margin-left: auto;margin-right: auto;"><canvas ref="chartCanvas"></canvas></div>
    </v-col>
</template>

<script lang="ts">
    import Vue from 'vue';
//    import Chart from 'chart.js/auto';
    import {Chart,registerables, ChartComponentLike, ChartDataset, ChartEvent, LegendItem} from "chart.js";
    Chart.register(...registerables);
    const colors = ["#2196F3","#009688","#9C27B0","#03A9F4","#8BC34A","#FF9800"];
    const border = {
        "normal":{
            "color":"#FFFFFF",
            "width":0,
        },
        "emphasis":{
            "color":"#F44336",
            "width":5,
        }
    }
    export default Vue.extend({
        data: () => ({
            chartData:null as null|Chart,
            dataSets:null as ChartDataset[]|null,
            labels:[] as Array<string>,
            title:"",
            columnId:null as null|number,
            onCanvas:false,
            onLegends:false,
            curDatasets:{
                data:[] as number[],
                labels:[] as string[],
                emphasis:null as null|number,
            }
        }),
        methods:{
            sysSet(id:number,title:string){
                this.title = title;
                this.columnId = id;
            },
            update(datasets:{data:number[],labels:string[],emphasis?:number}){
                this.curDatasets.data = datasets.data;
                this.curDatasets.labels = datasets.labels;
                this.curDatasets.emphasis = datasets.emphasis??null;
                const ref = this.$refs.chartCanvas as HTMLCanvasElement;
                this.labels = datasets.labels;
                const bgColor = [] as Array<string>;
                const borderColor = [] as Array<string>;
                const borderWidth = [] as Array<number>;
                const order = [] as Array<number>;
                for(let i=0;i<datasets.data.length;i++){
                    bgColor.push(colors[i%(colors.length-1)]);
                    if(typeof datasets.emphasis === "number" && datasets.emphasis === i){
                        borderColor.push(border.emphasis.color);
                        borderWidth.push(border.emphasis.width);
                        order.push(0);
                    }else{
                        borderColor.push(border.normal.color);
                        borderWidth.push(border.normal.width);
                        order.push(i+1);
                    }
                }
                this.dataSets = [
                    {"data":datasets.data,"backgroundColor":bgColor,"borderColor":borderColor,"borderWidth":borderWidth,"offset":3}
                ]
                if(this.chartData){
                    this.chartData.data = {"datasets":this.dataSets,"labels":this.labels};
                    this.chartData.options.animation = false;
                    this.chartData.update();
                }else{
                    if(ref){
                        const cvs = ref.getContext('2d');
                        ref.addEventListener("mousemove",this.mousePointerCheck);
                        if(cvs && this.dataSets){
                            this.chartData = new Chart(cvs,{
                                "type":"pie",
                                "data":{"datasets":this.dataSets,"labels":this.labels},
                                "options":{
                                    "maintainAspectRatio":true,
                                    "onClick":this.chartClick,
                                    "plugins":{
                                        "title":{
                                            "display":true,
                                            "text":this.title,
                                        },
                                        "legend":{
                                            "reverse":true,
                                            "onClick":this.legendsClick,
                                            "onHover":()=>{this.onLegends=true;this.changeCorsor(true)},
                                            "onLeave":()=>{this.onLegends=false;this.changeCorsor(false)},
                                        }
                                    }
                                }
                            });
                        }
                    }
                }
            },
            resetEmphasis(activeId:number|null){
                if(activeId === null || this.columnId !== activeId){
                    this.curDatasets.emphasis = null;
                    this.update({"data":this.curDatasets.data,"labels":this.curDatasets.labels});
                }
            },
            selectEmphasis(indexId:number){
                const emphasis = {
                    "columnId":this.columnId,
                    "title":this.title,
                    "item":"",
                    "set":true,
                }
                if(indexId !== this.curDatasets.emphasis){
                    emphasis.item = this.labels[indexId];
                    this.update({"data":this.curDatasets.data,"labels":this.curDatasets.labels,"emphasis":indexId});
                }else{
                    emphasis.set = false;
                    this.update({"data":this.curDatasets.data,"labels":this.curDatasets.labels});
                }
                this.$emit("emphasisSetEvent",emphasis);
            },
            legendsClick(e:ChartEvent,l:any){
                if(l){
                    this.selectEmphasis(l.index)
                }
            },
            chartClick(e:ChartEvent){
                if(this.chartData && e.native){
                    const clickData = this.chartData.getElementsAtEventForMode(e.native,'nearest', { intersect: true }, true);
                    this.selectEmphasis(clickData[0].index);
                }
            },
            mousePointerCheck(e:Event){
                if(this.chartData && !this.onLegends){
                    const cData = this.chartData.getElementsAtEventForMode(e,'nearest', { intersect: true }, true);
                    if(cData.length > 0 && !this.onCanvas){
                        this.changeCorsor(true);
                    }else if(cData.length === 0 && this.onCanvas){
                        this.changeCorsor(false);
                    }
                }
            },
            changeCorsor(pointer:boolean){
                const ref = this.$refs.chartCanvas as HTMLCanvasElement;
                if(pointer && !this.onCanvas){
                    this.onCanvas = true;
                    ref.style.cursor = "pointer"
                }else if(!pointer && this.onCanvas){
                    this.onCanvas = false;
                    ref.style.cursor = "auto";
                }
                return true;
            },
            getLegend(){
                if(this.chartData){
                    return this.chartData.chartArea.top;
                }else{
                    return null;
                }
            },
            setPadding(padding:number){
                if(this.chartData && this.chartData.options.layout && this.chartData.options.plugins && this.chartData.options.plugins.title){
                    this.chartData.options.plugins.title.padding = {"bottom":padding};
                    this.chartData.options.animation = {"duration":0};
                    this.chartData.update();
                }
            }
        }
    });
</script>
